import React from "react";
import Isocompliance from "../assets/svg/Iso_logo.svg";

const MainImage = () => {
  return (
    <>
      <img src={Isocompliance} alt="Isocompliance" className="md:h-28 mt-5" />
    </>
  );
};

export default MainImage;
